/* eslint-disable no-unused-vars */

export const CLUSTER_TOAST_ID = 'cluster-toast-id';

export const clusterMessages = {
    SUCCEEDED: 'Successfully edited cluster',
    FAILED: 'An error occurred edited cluster',
};

export const clusterStatuses = {
    ENABLED: 'enabled',
};

export const CLUSTER_FIELDS_FUNCTIONS = {
    budget: {
        field: 'budget',
        columnName: 'budget',
        updateClusterField: (cluster, newValue) => ({
            ...cluster,
            ranges: [{
                ...cluster.ranges[0],
                budget: newValue,
            }],
        }),
        getFieldActualValue: cluster => cluster?.ranges[0]?.budget,
        getDefaultValue: value => value,
    },
    paceBudget: {
        field: 'paceBudget',
        columnName: 'pace_budget',
        updateClusterField: (cluster, newValue) => ({
            ...cluster,
            paceBudget: newValue,
        }),
        getFieldActualValue: cluster => cluster?.paceBudget,
        getFieldDefaultValue: _ => 10,
    },
    paceTarget: {
        field: 'paceTarget',
        columnName: 'pace_target',
        updateClusterField: (cluster, newValue) => ({
            ...cluster,
            paceTarget: newValue,
        }),
        getFieldActualValue: cluster => cluster?.paceTarget,
        getFieldDefaultValue: _ => 7.1,
    },
    minimumPerformanceValue: {
        field: 'minimumPerformanceValue',
        columnName: 'minimum_performance_value',
        updateClusterField: (cluster, newValue) => ({
            ...cluster,
            minimumPerformanceValue: newValue,
        }),
        getFieldActualValue: cluster => cluster?.minimumPerformanceValue || null,
        getFieldDefaultValue: _ => null,
    },
    minimumDailyBudgetValue: {
        field: 'minimumDailyBudgetValue',
        columnName: 'minimum_daily_budget_value',
        updateClusterField: (cluster, newValue) => ({
            ...cluster,
            minimumDailyBudgetValue: newValue,
        }),
        getFieldActualValue: cluster => cluster?.minimumDailyBudgetValue || null,
        getFieldDefaultValue: _ => null,
    },
    performanceWindow: {
        field: 'performanceWindow',
        columnName: 'performance_window',
        updateClusterField: (cluster, newValue) => ({
            ...cluster,
            performanceWindow: newValue,
        }),
        getFieldActualValue: cluster => cluster?.performanceWindow,
        getFieldDefaultValue: _ => 7,
    },
    daysBetweenAdjustmentsBudget: {
        field: 'daysBetweenAdjustmentsBudget',
        columnName: 'days_between_adjustments_budget',
        updateClusterField: (cluster, newValue) => ({
            ...cluster,
            daysBetweenAdjustmentsBudget: newValue,
        }),
        getFieldActualValue: cluster => cluster?.daysBetweenAdjustmentsBudget,
        getFieldDefaultValue: _ => 1,
    },
    daysBetweenAdjustmentsTarget: {
        field: 'daysBetweenAdjustmentsTarget',
        columnName: 'days_between_adjustments_target',
        updateClusterField: (cluster, newValue) => ({
            ...cluster,
            daysBetweenAdjustmentsTarget: newValue,
        }),
        getFieldActualValue: cluster => cluster?.daysBetweenAdjustmentsTarget,
        getFieldDefaultValue: _ => 1,
    },
};
